<!--1-1-2页面-->
<template>
  <PanelV2
    type="w8"
    title="aaa"
  >
    <template v-slot:content-solt>
      <div>
        BdoProgress
        <BdoProgress/>
      </div>

      <div>
        BdoRadio
        <BdoRadio/>
      </div>

      <div>
        BdoSelect
        <BdoSelect/>
      </div>

      <div>
        BeforeProceed
        <BeforeProceed/>
      </div>

      <div>
        BottomButton
        <BottomButton/>
      </div>

      <div>
        BusinessDescrption
        <BusinessDescrption/>
      </div>

      <div>
        BusinessNatrue
        <BusinessNatrue/>
      </div>

      <div>
        CityAndZipCode
        <CityAndZipCode/>
      </div>

      <div>
        DeleteBox
        <DeleteBox/>
      </div>

      <div>
        FormTitle
        <FormTitle/>
      </div>

      <div>
        IdAndPassword
        <IdAndPassword/>
      </div>

      <div>
        IDPhoto
        <IDPhoto/>
      </div>

      <div>
        LandlineNumber
        <LandlineNumber/>
      </div>

      <div v-if="false">
        Layout
        <Layout/>
      </div>

      <div>
        MobileNumber
        <MobileNumber/>
      </div>

      <div>
        MoreContactInfo
        <MoreContactInfo/>
      </div>

      <div>
        MoreMediaInfo
        <MoreMediaInfo/>
      </div>

      <div>
        MorePhoto
        <MorePhoto/>
      </div>

      <div>
        OnePhoto
        <OnePhoto/>
      </div>

      <div>
        Panel
        <Panel/>
      </div>

      <div>
        PanelTitle
        <PanelTitle/>
      </div>

      <div>
        PanelV2
        <PanelV2/>
      </div>

      <div>
        PrepareDocuments
        <PrepareDocuments/>
      </div>

      <div>
        PrivacyLine
        <PrivacyLine/>
      </div>

      <div>
        PrivacyPolicy
        <PrivacyPolicy/>
      </div>

      <div>
        ProvinceSelect
        <ProvinceSelect/>
      </div>

      <div>
        SaveImage
        <SaveImage/>
      </div>

      <div>
        ServicesHotLine
        <ServicesHotLine/>
      </div>

      <div>
        SideBar
        <SideBar/>
      </div>

      <div>
        Steps
        <Steps/>
      </div>

      <div>
        SuccessIdAndPassword
        <SuccessIdAndPassword/>
      </div>

      <div>
        TwoPageCredentials
        <TwoPageCredentials/>
      </div>

      <div>
        TwoPhoto
        <TwoPhoto/>
      </div>

      <div>
        ValidCards
        <ValidCards/>
      </div>

    </template>
  </PanelV2>
</template>

<script>
// eslint-disable-next-line
// import BdoIconSelect from "../components/BdoIconSelect.vue";
// eslint-disable-next-line
import BdoProgress from "../components/BdoProgress.vue";
// eslint-disable-next-line
import BdoRadio from "../components/BdoRadio.vue";
// eslint-disable-next-line
import BdoSelect from "../components/BdoSelect.vue";
// eslint-disable-next-line
import BeforeProceed from "../components/BeforeProceed.vue";
// eslint-disable-next-line
import BottomButton from "../components/BottomButton.vue";
// eslint-disable-next-line
import BusinessDescrption from "../components/BusinessDescrption.vue";
// eslint-disable-next-line
import BusinessNatrue from "../components/BusinessNatrue.vue";
// eslint-disable-next-line
import CityAndZipCode from "../components/CityAndZipCode.vue";
// eslint-disable-next-line
import DeleteBox from "../components/DeleteBox.vue";
// eslint-disable-next-line
import FormTitle from "../components/FormTitle.vue";
// eslint-disable-next-line
import IdAndPassword from "../components/IdAndPassword.vue";
// eslint-disable-next-line
import IDPhoto from "../components/IDPhoto.vue";
// eslint-disable-next-line
import LandlineNumber from "../components/LandlineNumber.vue";
// eslint-disable-next-line
import Layout from "../components/Layout.vue";
// eslint-disable-next-line
import MobileNumber from "../components/MobileNumber.vue";
// eslint-disable-next-line
import MoreContactInfo from "../components/MoreContactInfo.vue";
// eslint-disable-next-line
import MoreMediaInfo from "../components/MoreMediaInfo.vue";
// eslint-disable-next-line
import MorePhoto from "../components/MorePhoto.vue";
// eslint-disable-next-line
import OnePhoto from "../components/OnePhoto.vue";
// eslint-disable-next-line
import Panel from "../components/Panel.vue";
// eslint-disable-next-line
import PanelTitle from "../components/PanelTitle.vue";
// eslint-disable-next-line
import PanelV2 from "../components/PanelV2.vue";
// eslint-disable-next-line
import PrepareDocuments from "../components/PrepareDocuments.vue";
// eslint-disable-next-line
import PrivacyLine from "../components/PrivacyLine.vue";
// eslint-disable-next-line
import PrivacyPolicy from "../components/PrivacyPolicy.vue";
// eslint-disable-next-line
import ProvinceSelect from "../components/ProvinceSelect.vue";
// eslint-disable-next-line
import SaveImage from "../components/SaveImage.vue";
// eslint-disable-next-line
import ServicesHotLine from "../components/ServicesHotLine.vue";
// eslint-disable-next-line
import SideBar from "../components/SideBar.vue";
// eslint-disable-next-line
import Steps from "../components/Steps.vue";
// eslint-disable-next-line
import SuccessIdAndPassword from "../components/SuccessIdAndPassword.vue";
// eslint-disable-next-line
import TwoPageCredentials from "../components/TwoPageCredentials.vue";
// eslint-disable-next-line
import TwoPhoto from "../components/TwoPhoto.vue";
// eslint-disable-next-line
import ValidCards from "../components/ValidCards.vue";

export default {
  name:'Demo',
  pRouter:'App',
  components:{
    // BdoIconSelect,
    BdoProgress,
    BdoRadio,
    BdoSelect,
    BeforeProceed,
    BottomButton,
    BusinessDescrption,
    BusinessNatrue,
    CityAndZipCode,
    DeleteBox,
    FormTitle,
    IdAndPassword,
    IDPhoto,
    LandlineNumber,
    Layout,
    MobileNumber,
    MoreContactInfo,
    MoreMediaInfo,
    MorePhoto,
    OnePhoto,
    Panel,
    PanelTitle,
    PanelV2,
    PrepareDocuments,
    PrivacyLine,
    PrivacyPolicy,
    ProvinceSelect,
    SaveImage,
    ServicesHotLine,
    SideBar,
    Steps,
    SuccessIdAndPassword,
    TwoPageCredentials,
    TwoPhoto,
    ValidCards,
  },
  created(){
    window.loadI18NData('en', () => {});
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>

</style>
